"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var getMonthDiff = function (dateFrom, dateTo) {
    return (dateTo.getMonth() -
        dateFrom.getMonth() +
        12 * (dateTo.getFullYear() - dateFrom.getFullYear()));
};
exports.default = getMonthDiff;
